// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

// immersive toggles a true full-screen surface on the native Android app — used by the
// call screen so it feels like a native call (the OS status bar / "headings" disappear,
// leaving only the call's own controls). No-op on the web build (browsers manage their
// own chrome). Best-effort: a missing plugin or a denied call is swallowed.
import { isNativeApp } from "./server";

let depth = 0; // ref-count, so nested/overlapping enters don't prematurely restore chrome

export async function enterImmersive(): Promise<void> {
  if (!isNativeApp()) return;
  depth++;
  try {
    const { StatusBar } = await import("@capacitor/status-bar");
    await StatusBar.hide();
  } catch {
    /* plugin absent — the overlay still covers the screen */
  }
}

export async function exitImmersive(): Promise<void> {
  if (!isNativeApp()) return;
  depth = Math.max(0, depth - 1);
  if (depth > 0) return; // another caller still wants immersive
  try {
    const { StatusBar } = await import("@capacitor/status-bar");
    await StatusBar.show();
  } catch {
    /* nothing to restore */
  }
}
